import { render, staticRenderFns } from "./topic-exposition.vue?vue&type=template&id=0c1d2339&scoped=true&"
import script from "./topic-exposition.vue?vue&type=script&lang=js&"
export * from "./topic-exposition.vue?vue&type=script&lang=js&"
import style0 from "./topic-exposition.vue?vue&type=style&index=0&id=0c1d2339&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1d2339",
  null
  
)

export default component.exports